import { HttpInterceptorFn, provideHttpClient, withInterceptors } from "@angular/common/http";
import { ApplicationConfig, ErrorHandler } from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter, TitleStrategy, withComponentInputBinding } from "@angular/router";

import { provideAngularSvgIcon } from "angular-svg-icon";

import { authInterceptor } from "@core/interceptors/auth.interceptor";
import { httpErrorInterceptor } from "@core/interceptors/http-error-inerceptor.service";
import { GlobalErrorHandler } from "@core/services/global-error-handler.service";
import { TitleService } from "@core/services/title.service";

import { routes } from "./app.routes";

const withCredentialsInterceptor: HttpInterceptorFn = (req, next) => {
  return next(
    req.clone({
      withCredentials: true
    })
  );
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideRouter(routes, withComponentInputBinding()),
    {
      provide: TitleStrategy,
      useClass: TitleService
    },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideHttpClient(withInterceptors([httpErrorInterceptor, withCredentialsInterceptor, authInterceptor])),
    provideAngularSvgIcon()
  ]
};
